"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ChopText;
var _react = _interopRequireWildcard(require("react"));
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip"));
var _classnames = _interopRequireDefault(require("classnames"));
var _useHover = _interopRequireDefault(require("../hooks/useHover"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _makeStyles.default)({
  text: {
    overflow: 'hidden',
    textOverflow: p => p.showEllipsis ? 'ellipsis' : 'clip',
    whiteSpace: p => p.lineCount === 1 ? 'nowrap' : 'inherit',
    display: p => p.lineCount === 1 ? '' : '-webkit-box',
    lineHeight: p => p.lineCount === 1 ? '' : 1.1,
    '-webkitLineClamp': p => p.lineCount === 1 ? '' : p.lineCount,
    '-webkitBoxOrient': p => p.lineCount === 1 ? '' : 'vertical'
  }
});
/** Renders a Typography component wrapped with Tooltip that only opens if the text is overflowing */
function ChopText({
  children,
  lineCount = 1,
  showEllipsis,
  isHovering: externalHovering,
  tooltipProps,
  className,
  ...rest
}) {
  const ref = (0, _react.useRef)(null);
  const isHovering = externalHovering !== undefined ? externalHovering : (0, _useHover.default)(ref);
  const open = isHovering && !!ref.current && ref.current.scrollWidth > ref.current.clientWidth;
  const classes = useStyles({
    open,
    lineCount,
    showEllipsis
  });
  if (!children) return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {});
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
    title: children,
    open: open,
    placement: "right",
    arrow: true,
    TransitionProps: {
      timeout: {
        enter: 200,
        exit: 0
      }
    },
    ...tooltipProps,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
      display: "block",
      className: (0, _classnames.default)(classes.text, className),
      ref: ref,
      ...rest,
      children: children
    })
  });
}